import type { DataSource } from '../types/siteRag';

const SENTIMENT_FIELD_HINTS = [
  'publicsentiment',
  'public_sentiment',
  'sentiment',
  'sitecontext',
  'siteresearch',
  'gdelt',
  'minutes',
  'docket',
  'community',
  'stakeholder',
];

const NON_SENTIMENT_FIELD_PREFIXES = [
  'grid',
  'climate',
  'seismic',
  'flood',
  'solar',
  'wind',
  'electricity',
  'airquality',
  'connectivity',
  'land.',
  'land_',
  'nrc',
  'regulatory',
  'infrastructure',
  'parcel',
  'water',
  'transport',
  'cooling',
  'lcoe',
  'btm',
];

/**
 * Keep references that plausibly informed public-sentiment analysis.
 * Used by the PSR appendix/sources list so grid/BTM provider rows
 * do not dominate a sentiment deliverable.
 */
export function filterSentimentInfluencingReferences(refs: DataSource[]): DataSource[] {
  return refs.filter(isSentimentInfluencingReference);
}

export function isSentimentInfluencingReference(ref: DataSource): boolean {
  const field = ref.field.toLowerCase();
  const source = ref.source.toLowerCase();

  if (SENTIMENT_FIELD_HINTS.some(h => field.includes(h) || source.includes(h))) {
    return true;
  }

  if (NON_SENTIMENT_FIELD_PREFIXES.some(p => field.startsWith(p) || field.includes(`.${p}`))) {
    return false;
  }

  // Knowledge / uploaded documents / DAM may carry sentiment-relevant citations.
  if (
    field.includes('knowledge')
    || field.includes('document')
    || field.includes('dam')
    || field.includes('library')
    || field.includes('adams')
  ) {
    return true;
  }

  return false;
}
